var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResultsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "9.409 29.525 64 12.821 118.591 29.525 64 51.464 9.409 29.525",
    style: {
      fill: "#c59e78"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64 12.821 64 49.306 68.591 51.464 116.926 32.143 118.591 29.525 64 12.821",
    style: {
      fill: "#231f20",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64 115.179 118.591 95.398 118.591 29.525 62.274 49.931 64 115.179",
    style: {
      fill: "#a7805a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64 115.179 9.409 93.692 9.409 29.525 64 49.306 64 115.179",
    style: {
      fill: "#d7b18f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 58.55 54.892 79.528 64 49.306 9.409 29.525 0 58.55",
    style: {
      fill: "#d7b18f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 58.55 54.892 79.528 64 49.306 9.409 29.525 0 58.55",
    style: {
      fill: "#fff",
      opacity: 0.17,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128 58.55 73.108 79.528 64 49.306 118.591 29.525 128 58.55",
    style: {
      fill: "#a7805a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128 58.55 73.108 79.528 64 49.306 118.591 29.525 128 58.55",
    style: {
      fill: "#231f20",
      opacity: 0.1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsIcon);
export default __webpack_public_path__ + "static/media/noResultsIcon.12377908.svg";
export { ForwardRef as ReactComponent };